import { getContactCategoriesList } from "../../../app/api/getContactCategoriesList";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IApiResponse } from "../../../Orchestrator/Types/Index";
import {
  IContactCategoryConfigResponse,
} from "../../../Orchestrator/Types/Interface/ICustomerContact";

class GetContactCategoriesAction extends BaseAction<
  IContactCategoryConfigResponse,
  void
> {
  // Called from CustomerContactFlow, the corporate-account flow, and the
  // terms-and-conditions page; coalesce concurrent fetches into one request.
  protected override deduplicate = true;

  override async run(): Promise<IContactCategoryConfigResponse | null> {
    let categoriesResponse: IContactCategoryConfigResponse = {};

    try {
      const response: IApiResponse<IContactCategoryConfigResponse> =
        await getContactCategoriesList();

      if (response.status === "ok" && response.answer) {
        const data = response.answer;
        if (data) {
          categoriesResponse = response.answer;
          updateRecoilState("contactCategoriesAtom", data);
        } else {
          console.warn("No categories data available.");
        }
      } else {
        console.warn("Failed to fetch categories data.");
      }
    } catch (error: any) {
      console.error("Error fetching categories data:", error);
    } finally {
      return categoriesResponse;
    }
  }
}

export const getContactCategoriesAction = new GetContactCategoriesAction();